import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { TOKEN_LOCAL_STORAGE_KEY } from '../services/auth.service';
import { catchError, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (req.headers.has('Authorization')) {
      return next.handle(req);
    }

    // Intentar obtener iframeToken desde la URL
    const urlParams = new URLSearchParams(window.location.search);
    const iframeToken = urlParams.get('iframeToken');

    // Si existe el iframeToken, usarlo directamente en la autenticación
    const token = iframeToken ? iframeToken : localStorage.getItem(TOKEN_LOCAL_STORAGE_KEY);


    // Si el token existe, clona la solicitud y agrega el encabezado Authorization
    if (token && this.validUrlToApplyAuthorization(req.url)) {
      const clonedRequest = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });

      // Continúa con la solicitud clonada
      return next.handle(clonedRequest).pipe(
        catchError((error: HttpErrorResponse) => {
          // Si el error es 401 (Unauthorized), la sesión ha caducado
          if (error.status === 401 || error.status === 403) {
            this.handleSessionExpired();
          }
          return throwError(error);
        })
      );
    }

    // Si no hay token, continúa con la solicitud original
    return next.handle(req);
  }

  private handleSessionExpired(): void {
    // Elimina el token de localStorage
    localStorage.removeItem(TOKEN_LOCAL_STORAGE_KEY);

    // Redirige al usuario a la página de inicio de sesión
    this.router.navigate(['/authentication/login']);
  }

  private validUrlToApplyAuthorization(url: string): Boolean {

    if (url.includes('wikyscan-2021-dev.s3') || url.includes('wikyscan-2021.s3') || url.includes('public') || url.includes('pdf-services-ue1.adobe') || url.includes('dcplatformstorageservice') ||
      url.includes('volumental.com') ||
      url.includes('login.volumental.com') ||
      url.includes('widget.volumental.com')) {
      return false;
    }

    return true;
  }
}
